/**
 * @generated SignedSource<<8b5e146c3c149ba670ab9f47b1aa30ff>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileListItem_profile$data = {
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileAvatar_profile">;
  readonly " $fragmentType": "ProfileListItem_profile";
};
export type ProfileListItem_profile$key = {
  readonly " $data"?: ProfileListItem_profile$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileListItem_profile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileListItem_profile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProfileAvatar_profile"
    }
  ],
  "type": "Profile",
  "abstractKey": null
};

(node as any).hash = "42f8cfb6d66a3107ea687eb9550a9b7f";

export default node;
